import { render, staticRenderFns } from "./Monitor.vue?vue&type=template&id=279bd326&scoped=true"
import script from "./Monitor.vue?vue&type=script&lang=ts"
export * from "./Monitor.vue?vue&type=script&lang=ts"
import style0 from "./Monitor.vue?vue&type=style&index=0&id=279bd326&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "279bd326",
  null
  
)

export default component.exports